import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getClientSuggestedServices } from "../slice//clientPanelSuggestedServicesSlice";
import { getServiceTypes } from '../../client-services/slice/clientServicesSlice';

const ClientSuggestedServices = () => {
    const dispatch = useDispatch();
    const { clientSuggestedServices = [] } = useSelector((state) => state.clientSuggestedServices);
    const { serviceTypes  } = useSelector((state) => state.clientServices);
    const clientToken = localStorage.getItem("client_access_token");

    useEffect(() => {
        dispatch(getClientSuggestedServices(clientToken));
        dispatch(getServiceTypes());
    }, [dispatch]);

      console.log("clientSuggestedServices", clientSuggestedServices);
      const getServiceTypeName = (typeId) => {
    const matchedType = serviceTypes.find(type => type.id === Number(typeId));
    return matchedType ? matchedType.issue_type : 'Unknown Type';
  };
    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">Suggested Services</h4>
                    <div className="form-section mt-3">
                <main className="overflow-hidden">
                    <section className="homepad pt-0" style={{ minHeight: "60vh" }}>
                              <div className="container">
                                <div className="row d-flex align-items-stretch">
                                  <div className="col-lg-8 services-listpage">
                                    <div className="pe-xl-3">
                              {(!clientSuggestedServices || clientSuggestedServices.length === 0) ? (
                      <div className="text-center py-5">
                        <h5 className="text-muted">No services available</h5>
                      </div>
                    ) : (
                      clientSuggestedServices.map((service) => {
                                        const providerImageBaseUrl = process.env.REACT_APP_PROVIDER_IMAGE_BACKEND_URL;
                                        const firstImage = service.provider?.images?.[0]?.image_name ?? 'default.png';
                                        const backgroundImageUrl = `${providerImageBaseUrl}/${firstImage}`;
                    
                                        return (
                                          <div
                                            className="row"
                                            key={service.id}
                                            onClick={() => window.open(`/client-service/details/${service.id}`, '_blank')}
                                            style={{
                                              cursor: "pointer"
                                            }}
                                          >
                                            <div className="col-12">
                                              <div className="card activity-card d-md-flex flex-md-row p-4">
                                                <div
                                                  className="position-relative services-list-box"
                                                  style={{
                                                    background: `url(${backgroundImageUrl}) no-repeat`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    width: '25%',
                                                    // height: '50%'
                                                  }}
                                                >
                                                  {/* <span className="badge badge-custom position-absolute bottom-0 start-0 m-2 font-weight-medium font-size-14 text-primary px-3 py-2">
                                                    {Array.isArray(service.language_support) && service.language_support.length > 0 ? 'Bilingual' : ''}
                                                  </span> */}
                                                  <a href="#" className="text-decoration-none position-absolute top-0 end-0 m-2">
                                                    <i className="fa fa-heart-o text-white font-size-22" aria-hidden="true"></i>
                                                  </a>
                                                </div>
                                                <div className="card-body py-0 pe-0 ps-0 ps-md-4 ms-xl-1 mt-4 mt-md-0">
                                                  <h6 className="font-weight-bold text-primary font-size-22 mb-3 line-hight-2 montserrat">
                                                    {service.service_name}
                                                  </h6>
                                                  <div className="text-muted font-size-14 mb-2">
                                                    <strong>Type: </strong>{getServiceTypeName(service.service_type)}
                                                  </div>
                                                  <div className="text-danger-dark font-size-16 font-weight-medium mb-3">
                                                    by {service.provider?.company_name || 'Unknown Provider'}
                                                  </div>
                                                  <p dangerouslySetInnerHTML={{ __html: service.service_description }} />
                                                  <div className="d-flex justify-content-between align-items-center mt-4">
                                                    <div className="d-flex align-items-center flex-wrap">
                                                      <span className="price me-3 text-danger-dark font-size-26 font-weight-medium">
                                                        ${service.amount_per_session || 'N/A'}
                                                      </span>
                                                      { service.service_mode != '' ? (
                                                        <span className="mt-1 rounded bg-light text-dark font-weight-normal py-2 px-3 me-2">
                                                          
                                                          <img
                                                            src="/assets/images/bxsdydbjmcutirye.svg"
                                                            className="img-fluid me-2"
                                                            alt="Activity"
                                                          />
                    
                                                          {Array.isArray(service.service_mode)
                                                            ? service.service_mode.join(', ')
                                                            : service.service_mode}
                                                          
                                                        </span>
                                                      ) : ( '' )
                                                      }
                                                      { service.from_age != null ? (
                    
                                                         <span className="mt-1 rounded bg-light text-dark font-weight-normal py-2 px-3">
                    
                                                           Ages {service.from_age} - {service.to_age} years
                    
                                                         </span>
                    
                                                       ) : ('')
                    
                                                     }
                                                    </div>
                                                    <span className="rating-badge bg-primary font-size-16 rounded-pill text-white" onClick={() => window.open(`/client-service/details/${service.id}`, '_blank')}>
                                                      <img
                                                        src="/assets/images/eye.png"
                                                        className="img-fluid me-1"
                                                        alt="Activity"
                                                        width="20"
                                                      />
                                                      View Details
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })
                                      )}
                    
                                    </div>
                                  </div>
                            
                                 
                                </div>
                              </div>
                            </section>
                </main>
                </div>
                </div>
            </div>
        </>
    );
};

export default ClientSuggestedServices;